import {StyleSheet} from 'react-native';
import {Theme} from '@lookiero/aurora';

const style = () => {
  const {space8} = Theme.get();

  return StyleSheet.create({
    infoBox: {
      maxWidth: 400,
      marginTop: space8,
    },
  });
};

export {style};
